import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import useSbt from "../hooks/sbtHook";
import useLocalStorageBackedList from "../hooks/localStorageListHook";

const useKnownGoodSbtStore = (key = "knownContracts") => {
  const list = useLocalStorageBackedList(key);

  return {
    sbtContracts: list.values,
    addSbtContract: list.addValue,
  };
};

const SbtSelector = ({ sbtContractId, setSbtContractId }) => {
  const sbt = useSbt();
  const { sbtContracts, addSbtContract } = useKnownGoodSbtStore();

  const setContractId = (value) => {
    setSbtContractId(value);
    sbt.getContractMetadata(value).then((result) => {
      if (result?.spec?.match(/^sbt-\d/)) {
        addSbtContract(value);
      }
    });
  };

  return (
    <Autocomplete
      freeSolo
      value={sbtContractId || ""}
      onChange={(e, newValue) => {
        setContractId(newValue || "");
      }}
      options={sbtContracts}
      renderInput={(params) => (
        <TextField
          {...params}
          label="SBT Contract ID"
          onChange={(e) => setContractId(e.target.value || "")}
        />
      )}
    />
  );
};

export default SbtSelector;
